import { useQuery } from '@tanstack/react-query'

import { getAllIndustries } from '../industriesApi'
import { industriesKeys } from '../queryKeys/industriesKeys'

const useGetIndustriesQuery = () => {
  return useQuery({
    queryKey: industriesKeys.list(),
    queryFn: getAllIndustries,
    staleTime: 1000 * 60 * 60,
  })
}
export default useGetIndustriesQuery
